// extracted by mini-css-extract-plugin
module.exports = {"boardContainer":"boardContainer_boardContainer__2Owmy"};